/* global google */
/* global jQuery */
/* global require */
'use strict'; //eslint-disable-line
const util = require('util');

angular
  .module('serviceArea')
  .component('serviceArea', {
    template: require('./area.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$timeout', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function ServiceAreaController($rootScope, $scope, $resource, $route, $location, $window, $timeout, $translate, AuthService, envService, uiGmapGoogleMapApi, CenterInfo) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'area';
        $scope.map = { control: {}, center: { latitude: CenterInfo.center.latitude, longitude: CenterInfo.center.longitude }, zoom: 12 };
        $scope.addMap = {
          control: {},
          center: { latitude: CenterInfo.center.latitude, longitude: CenterInfo.center.longitude },
          zoom: 12,
          events: {
            click: (map, eventName, args) => {
              if (!this.drawingOn) { return; }
              const latLng = args[0] && args[0].latLng;
              if (!latLng) { return; }
              this.drawPoints.push({
                id: Date.now() + this.drawPoints.length,
                latitude: latLng.lat(),
                longitude: latLng.lng(),
              });
              this.syncDrawnShape();
              $scope.$applyAsync();
            },
          },
        };
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        let targetPage = 1;
        this.pageSize = 20;
        this.currentPage = 1;
        this.totalCount = 0;
        this.query = '';
        this.modifyMode = false;
        this.editingArea = {};
        this.targetTbCityId = '-1';
        this.cities = [];
        this.listPolygons = [];
        const drawPolylineOnMap = (polyline) => {
          let path = '';
          if (polyline && polyline.length > 0) {
            path = polyline.trim().replace('\n', '\\n');
          }
          uiGmapGoogleMapApi.then(() => {
            if (!path || path.length < 1) { return; }
            this.polylines = [
              {
                id: 1,
                path: google.maps.geometry.encoding.decodePath(path),
                stroke: {
                  color: '#5694cc',
                  weight: 2,
                },
                fill: {
                  color: '#5694cc',
                },
                editable: false,
                draggable: false,
                geodesic: false,
                visible: true,
              },
            ];
          });
        };
        const errorHandler = (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        };
        const panAddMapTo = (lat, lng) => {
          $scope.addMap.center.latitude = lat;
          $scope.addMap.center.longitude = lng;
          uiGmapGoogleMapApi.then(() => {
            if (!$scope.addMap.control.getGMap) { return; }
            const map = $scope.addMap.control.getGMap();
            if (!map) { return; }
            map.panTo(new google.maps.LatLng({ lat, lng }));
            map.setZoom(12);
          });
        };
        const clearListPolygons = () => {
          (this.listPolygons || []).forEach((poly) => {
            poly.setMap(null);
          });
          this.listPolygons = [];
        };
        const redrawListMap = () => {
          uiGmapGoogleMapApi.then(() => {
            if (!$scope.map.control.getGMap) { return; }
            const map = $scope.map.control.getGMap();
            if (!map) { return; }
            clearListPolygons();
            const bounds = new google.maps.LatLngBounds();
            let hasPath = false;
            (this.areas || []).forEach((area) => {
              if (!area._showMap || !area.POLYLINE) { return; }
              let path;
              try {
                path = google.maps.geometry.encoding.decodePath(String(area.POLYLINE).trim());
              } catch (e) {
                return;
              }
              if (!path || !path.length) { return; }
              const color = area.COLOR || '#5694cc';
              const poly = new google.maps.Polygon({
                paths: path,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.35,
                map,
              });
              this.listPolygons.push(poly);
              path.forEach((latLng) => {
                bounds.extend(latLng);
                hasPath = true;
              });
            });
            if (hasPath) {
              map.fitBounds(bounds);
            }
            google.maps.event.trigger(map, 'resize');
          });
        };
        const normalizeAreaFlags = (areas) => (areas || []).map((area) => {
          const row = Object.assign({}, area);
          row._useAdmin = row.USE_ADMIN === 'Y';
          row._showMap = row.STATUS === 'A';
          return row;
        });
        const saveAreaFlags = (area) => $resource(`${APIURL}/admin/maps/${area.ID}`).save({
          STATUS: area._showMap ? 'A' : 'D',
          USE_ADMIN: area._useAdmin ? 'Y' : 'N',
          ABLE_STATUS: area.ABLE_STATUS,
          COLOR: area.COLOR,
        }).$promise.then((data) => {
          if (data && data.area) {
            area.STATUS = data.area.STATUS;
            area.USE_ADMIN = data.area.USE_ADMIN;
          } else {
            area.STATUS = area._showMap ? 'A' : 'D';
            area.USE_ADMIN = area._useAdmin ? 'Y' : 'N';
          }
          area._useAdmin = area.USE_ADMIN === 'Y';
          area._showMap = area.STATUS === 'A';
          redrawListMap();
        });
        const selectedCityCoords = () => {
          const selectedCities = (this.cities || []).filter(city => String(city.ID) === String(this.addArea.TB_CITY_ID));
          if (selectedCities.length < 1) { return null; }
          const selectedCity = selectedCities[0];
          if (selectedCity.LAT === null || selectedCity.LAT === undefined || selectedCity.LON === null || selectedCity.LON === undefined) { return null; }
          return { lat: parseFloat(selectedCity.LAT), lng: parseFloat(selectedCity.LON) };
        };
        const getCenterInfo = () => {
          $resource(`${APIURL}/admin/maps/center`).get((centerInfo) => {
            CenterInfo.updateCenter(centerInfo.center.latitude, centerInfo.center.longitude);
            $scope.map.center = {
              latitude: centerInfo.center.latitude,
              longitude: centerInfo.center.longitude,
            };
            if (!this.addArea || !this.addArea.TB_CITY_ID) {
              panAddMapTo(centerInfo.center.latitude, centerInfo.center.longitude);
            }
            $timeout(() => redrawListMap(), 300);
          });
        };
        const getCities = () => {
          $resource(`${APIURL}/admin/maps/cities`).get({}, (data) => {
            this.cities = data.cities;
          }, (err) => {
            errorHandler(err);
          });
        };
        this.paging = (page) => {
          targetPage = page || 1;
          this.currentPage = targetPage;
          $resource(`${APIURL}/admin/maps/areas`).get({ PAGE: targetPage - 1, Q: this.query, TB_CITY_ID: this.targetTbCityId }, (data) => {
            this.areas = normalizeAreaFlags(data.areas);
            this.totalCount = data.totalCount;
            $timeout(() => redrawListMap(), 100);
          }, (err) => {
            errorHandler(err);
          });
        };
        this.allAssignChecked = () => (this.areas || []).length > 0 && (this.areas || []).every(a => a._useAdmin);
        this.allShowMapChecked = () => (this.areas || []).length > 0 && (this.areas || []).every(a => a._showMap);
        this.toggleAllAssign = ($event) => {
          const want = $event && $event.target ? !!$event.target.checked : !this.allAssignChecked();
          const jobs = (this.areas || []).filter(a => a._useAdmin !== want).map((area) => {
            area._useAdmin = want;
            return saveAreaFlags(area).catch((err) => {
              area._useAdmin = !want;
              errorHandler(err);
            });
          });
          Promise.all(jobs);
        };
        this.toggleAllShowMap = ($event) => {
          const want = $event && $event.target ? !!$event.target.checked : !this.allShowMapChecked();
          const jobs = (this.areas || []).filter(a => a._showMap !== want).map((area) => {
            area._showMap = want;
            return saveAreaFlags(area).catch((err) => {
              area._showMap = !want;
              errorHandler(err);
            });
          });
          Promise.all(jobs);
        };
        this.onToggleAssign = (area) => {
          const prev = !area._useAdmin;
          saveAreaFlags(area).catch((err) => {
            area._useAdmin = prev;
            errorHandler(err);
          });
        };
        this.onToggleShowMap = (area) => {
          const prev = !area._showMap;
          saveAreaFlags(area).catch((err) => {
            area._showMap = prev;
            errorHandler(err);
          });
        };
        getCities();
        getCenterInfo();
        this.paging(1);
        this.showAreaInfo = (area) => {
          this.selectedArea = area;
          // Open directly in edit mode — no extra "Modify" click.
          angular.copy(area, this.editingArea);
          this.editingArea._useAdmin = area.USE_ADMIN === 'Y' || area._useAdmin === true;
          this.editingArea._showMap = area.STATUS === 'A' || area._showMap === true;
          this.modifyMode = true;
          jQuery('#modal-areaInfo').modal('show');
        };
        this.showEmployees = (areaId) => {
          $resource(`${APIURL}/admin/maps/employees/${areaId}`).get((data) => {
            this.selectAreaEmployees = data.employees;
            jQuery('#modal-employeeInfo').modal('show');
          }, (err) => {
            errorHandler(err);
          });
        };
        this.modify = () => {
          const useAdmin = this.editingArea._useAdmin ? 'Y' : 'N';
          const status = this.editingArea._showMap ? 'A' : 'D';
          $resource(`${APIURL}/admin/maps/${this.editingArea.ID}`).save({
            STATUS: status,
            USE_ADMIN: useAdmin,
            ABLE_STATUS: this.editingArea.ABLE_STATUS,
            COLOR: this.editingArea.COLOR,
          }, (data) => {
            this.selectedArea = data.area || this.editingArea;
            jQuery('#modal-areaInfo').modal('hide');
            this.paging(targetPage);
          }, (err) => {
            errorHandler(err);
          });
        };
        this.delete = () => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/service/area/${this.selectedArea.ID}`).delete().$promise
            .then(() => {
              jQuery('#modal-areaInfo').modal('hide');
              this.paging(targetPage);
              alert($translate.instant('삭제되었습니다'));
            })
            .catch((err) => {
              errorHandler(err);
            });
        };
        this.drawPoints = [];
        this.drawingOn = true;
        this.syncDrawnShape = () => {
          const path = this.drawPoints.map(point => new google.maps.LatLng(point.latitude, point.longitude));
          this.polylines = path.length < 3 ? [] : [{
            id: 1,
            path,
            stroke: { color: '#FF7C00', weight: 2 },
            fill: { color: '#FF7C00' },
            editable: false,
            draggable: false,
            geodesic: false,
            visible: true,
          }];
          if (path.length < 3) {
            this.addArea.POLYLINE = '';
            return;
          }
          this.addArea.POLYLINE = google.maps.geometry.encoding.encodePath(path.concat([path[0]]));
        };
        this.undoPoint = () => {
          this.drawPoints.pop();
          if (google.maps && google.maps.geometry) { this.syncDrawnShape(); }
        };
        this.clearDrawing = () => {
          this.drawPoints = [];
          this.polylines = [];
          this.addArea.POLYLINE = '';
          this.drawingOn = true;
        };
        this.showViewAdd = () => {
          this.addArea = { _useAdmin: true, _showMap: true };
          this.isPreviewing = false;
          this.showDrawMap = false;
          this.drawingOn = true;
          this.drawPoints = [];
          this.polylines = [];
          const $modal = jQuery('#modal-addArea');
          $modal.off('shown.bs.modal.iwdraw');
          $modal.on('shown.bs.modal.iwdraw', () => {
            this.showDrawMap = true;
            $scope.$applyAsync();
            $timeout(() => {
              if ($scope.addMap.control.getGMap) {
                const map = $scope.addMap.control.getGMap();
                if (map) { google.maps.event.trigger(map, 'resize'); }
              }
            }, 200);
          });
          $modal.modal('show');
        };
        this.submitAdd = () => {
          this.addArea.NAME = (this.addArea.NAME || '').trim();
          this.addArea.POLYLINE = (this.addArea.POLYLINE || '').trim();
          if (!this.addArea.TB_CITY_ID) {
            alert($translate.instant('도시를 선택해주세요.'));
            return;
          }
          if (!this.addArea.NAME) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('지역명')));
            return;
          }
          if (!this.addArea.POLYLINE) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), 'POLYLINE'));
            return;
          }
          const payload = Object.assign({}, this.addArea, {
            USE_ADMIN: this.addArea._useAdmin ? 'Y' : 'N',
            STATUS: this.addArea._showMap ? 'A' : 'D',
          });
          delete payload._useAdmin;
          delete payload._showMap;
          $resource(`${APIURL}/admin/service/area`).save(payload).$promise
            .then(() => {
              jQuery('#modal-addArea').modal('hide');
              this.paging(targetPage);
            })
            .catch((err) => {
              errorHandler(err);
            });
        };
        this.previewArea = () => {
          this.isPreviewing = true;
          const coords = selectedCityCoords();
          if (coords) { panAddMapTo(coords.lat, coords.lng); }
          drawPolylineOnMap(this.addArea.POLYLINE || '');
        };
        this.closePreviewArea = () => {
          this.isPreviewing = false;
        };
        this.selectCity = () => {
          const coords = selectedCityCoords();
          if (!coords) { return; }
          panAddMapTo(coords.lat, coords.lng);
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/service/area/area.components.js